import { ComponentPropsWithoutRef, useState } from "react";
import GlobalNavAccount from "../../../../common/icons/GlobalNavAccount.tsx";
import { useIntl } from "react-intl";
import MyAccountDialogSwitcher from "../../layout/sidebar/my-account/MyAccountDialogSwitcher.tsx";
import HeaderButton from "./HeaderButton.tsx";

export default function MyAccountButton(
  props: ComponentPropsWithoutRef<typeof HeaderButton>
) {
  const intl = useIntl();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const label = intl.formatMessage({ defaultMessage: "My Account" });

  return (
    <>
      <HeaderButton
        aria-label={label}
        data-tooltip-content={label}
        onClick={() => setIsDialogOpen(true)}
        {...props}
      >
        <GlobalNavAccount />
      </HeaderButton>
      {isDialogOpen && (
        <MyAccountDialogSwitcher
          onRequestClose={() => setIsDialogOpen(false)}
        />
      )}
    </>
  );
}
